import classNames from 'classnames';
import { openUserManualDialog } from '../../../state/dialogs/useUserManualDialog';
import { useAppDispatch } from '../../../state/hooks';
import { UserManualDialogChaptersKeys } from '../../../state/dialogs/chapters';

type UserManualLinkProps = {
  chapter: UserManualDialogChaptersKeys;
  className?: string;
  dataTestId?: string;
};

export const UserManualLink = ({
  chapter,
  className,
  dataTestId,
}: UserManualLinkProps) => {
  const dispatch = useAppDispatch();
  return (
    <span
      className={classNames(
        'icon rioglyph rioglyph-question-sign cursor-pointer margin-5 text-color-info text-size-18',
        className,
      )}
      onClick={() => dispatch(openUserManualDialog(chapter))}
      data-testid={dataTestId ?? `info-link-span-${chapter}`}
    />
  );
};
